var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("h2", { staticClass: "mb-10" }, [_vm._v(_vm._s(_vm.title))]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Materia *" } },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.matter")
                        ? false
                        : null,
                      "data-cy": "matter",
                      "data-vv-as": "materia",
                      name: "matter",
                      maxLength: "500",
                      rows: "3",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.matter,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "matter", $$v)
                      },
                      expression: "formData.matter"
                    }
                  }),
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c("div", { staticClass: "col-md-6 text-left" }, [
                      _vm.errors.has("custom-document.matter")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.matter"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-md-6 text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de caracteres",
                              expression: "'Contador de caracteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.formData.matter.length) + "/500 "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Vistos *" } },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.seen")
                        ? false
                        : null,
                      "data-cy": "seen",
                      "data-vv-as": "vistos",
                      name: "seen",
                      maxLength: "5000",
                      rows: "3",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.seen,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "seen", $$v)
                      },
                      expression: "formData.seen"
                    }
                  }),
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c("div", { staticClass: "col-md-6 text-left" }, [
                      _vm.errors.has("custom-document.seen")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("custom-document.seen")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-md-6 text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de caracteres",
                              expression: "'Contador de caracteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.formData.seen.length) + "/5000 "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Considerando *" } },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.considering")
                        ? false
                        : null,
                      "data-cy": "considering",
                      "data-vv-as": "considerando",
                      name: "considering",
                      maxLength: "8000",
                      rows: "3",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.considering,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "considering", $$v)
                      },
                      expression: "formData.considering"
                    }
                  }),
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c("div", { staticClass: "col-md-6 text-left" }, [
                      _vm.errors.has("custom-document.considering")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.considering"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-md-6 text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de caracteres",
                              expression: "'Contador de caracteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formData.considering.length) +
                              "/8000 "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Resuelvo *" } },
                [
                  _c("editor-text", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "resolved",
                    attrs: {
                      danger: _vm.errors.has("custom-document.resolved"),
                      "danger-text": _vm.errors.first(
                        "custom-document.resolved"
                      ),
                      "data-cy": "resolved",
                      "data-vv-as": "resuelvo",
                      "max-length": _vm.maxLengthResolved,
                      name: "resolved",
                      "with-counter": ""
                    },
                    model: {
                      value: _vm.formData.resolved,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "resolved", $$v)
                      },
                      expression: "formData.resolved"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Imperativos *" } },
                [
                  _c("b-form-checkbox-group", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      "data-cy": "imperatives",
                      "data-vv-as": "imperativos",
                      name: "imperatives",
                      options: _vm.optionsImperatives
                    },
                    model: {
                      value: _vm.formData.imperatives,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "imperatives", $$v)
                      },
                      expression: "formData.imperatives"
                    }
                  }),
                  _vm.errors.has("custom-document.imperatives")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to"
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "custom-document.imperatives"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Cierre de la resolución" } },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        "data-cy": "closing-resolution",
                        name: "closingResolution",
                        value: true,
                        "unchecked-value": false
                      },
                      model: {
                        value: _vm.formData.closingResolution,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "closingResolution", $$v)
                        },
                        expression: "formData.closingResolution"
                      }
                    },
                    [
                      _vm._v(
                        " Por orden del señor Gobernador Regional en su calidad de ejecutivo del Gobierno Regional de la Región de Valparaíso. "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "col-md-6 mt-2" }, [
            _vm._v(" Orientación de documento "),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c(
                    "vs-radio",
                    {
                      attrs: {
                        "vs-name": "portrait",
                        "vs-value": "Portrait",
                        "data-cy": "portrait"
                      },
                      model: {
                        value: _vm.formData.orientation,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "orientation", $$v)
                        },
                        expression: "formData.orientation"
                      }
                    },
                    [_vm._v(" Vertical ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c(
                    "vs-radio",
                    {
                      attrs: {
                        "vs-name": "landscape",
                        "vs-value": "Landscape",
                        "data-cy": "landscape"
                      },
                      model: {
                        value: _vm.formData.orientation,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "orientation", $$v)
                        },
                        expression: "formData.orientation"
                      }
                    },
                    [_vm._v(" Horizontal ")]
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "row align-items-center mt-5" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c("UploadFile", {
                    attrs: {
                      permission: "*",
                      accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                      text: "Seleccionar documentos",
                      "upload-to": "ed",
                      "button-class": {
                        "btn-block": true,
                        "mb-5": _vm.errors.has("custom-document.fileName")
                      },
                      "container-class": "w-100"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addOthersFile()
                      }
                    },
                    model: {
                      value: _vm.fileOthers,
                      callback: function($$v) {
                        _vm.fileOthers = $$v
                      },
                      expression: "fileOthers"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "row align-items-center mt-1" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-3 align-items-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "ED060",
                            expression: "'ED060'"
                          },
                          {
                            name: "b-modal",
                            rawName: "v-b-modal",
                            value: "add-file-repository",
                            expression: "'add-file-repository'"
                          }
                        ],
                        staticClass: "btn-icon mt-1",
                        attrs: {
                          variant: "secondary",
                          "data-cy": "from-repository"
                        }
                      },
                      [
                        _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                        _vm._v(" Desde el repositorio ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._l(_vm.formData.attachments, function(file) {
                  return _c("div", { key: file.id, staticClass: "col-2" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "25px",
                            color: "primary"
                          }
                        }),
                        _c(
                          "b",
                          { staticClass: "text-truncate w-100 text-center" },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _c("vs-button", {
                          attrs: {
                            color: "danger",
                            type: "flat",
                            icon: "clear"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeOthersFile(file.id)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            ),
            !!_vm.error.messageOthers
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n        vs-input--text-validation-span v-enter-to text-left"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]),
        _c("FormButtons", {
          attrs: {
            saving: _vm.saving,
            back: _vm.back,
            save: _vm.save,
            saveDraft: _vm.saveDraft
          }
        }),
        _c("SelectDocRepository", {
          attrs: {
            "add-file": _vm.addFileRepo,
            files: _vm.formData.attachments,
            "remove-file": _vm.removeOthersFile
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }